module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/call/info-3793191bbc574151a159155cecdce9a9.svg";